import { z } from "zod/v4";
import type { $ZodIssue } from "zod/v4/core";

export * from "zod/v4"; // re-exporting zod types for convenience
export const event = z.object; // alias for readability and future extension.
export const oneOf = z.enum; // alias for readability and future extension.
export type ZodIssue = $ZodIssue;
